import checkbox from './checkbox';

export default {
    ...checkbox, name: 'select'
};
